export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}

/**
 * 지갑 인앱 브라우저 판별 (UA 기반).
 *
 * 역대 브랜드 표기를 전부 본다(CROSSx → ONEwallet → ONEpocket). 구버전 앱 빌드가
 * 필드에 오래 남으므로 최신 표기 하나만 보면 그 빌드가 통째로 미검출된다.
 * 표기 사이 공백(`One Wallet`)과 빌드 스킴 접미사(`+`, `:stage`)도 허용한다.
 */
const WALLET_UA_PATTERN = /CROSSx|ONE\s?wallet|ONE\s?pocket/i;

export function isInAppBrowser(): boolean {
  if (typeof window === "undefined") return false;
  return WALLET_UA_PATTERN.test(window.navigator.userAgent);
}
